import React from 'react'
import { DebounceInput } from 'react-debounce-input'

function FilterSearch(props) {
	// async function requestToServer(value) {
	// 	setFilterData({ ...filterData, 'search': value, page: 0 })
	// };

	return (
		<DebounceInput
			type="text"
			className="w-100"
			minLength={3}
			debounceTimeout={1000}
			// onChange={(e) => requestToServer(e.target.value)}
			onKeyUp={(e) => {
				// if (e.keyCode === 13) {
				// 	requestToServer(e.target.value)
				// }
			}}
			{...props}
		/>
	)
}

export default FilterSearch
